import {Dialog as Dialog2} from '@primer/react/experimental'

export function DangerConfirmationDialog({
  isOpen,
  title,
  text,
  buttonText,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  title: string
  text: string
  buttonText: string
  onDismiss: () => void
  onConfirm: () => void
}) {
  return (
    isOpen && (
      <Dialog2
        title={title}
        onClose={onDismiss}
        footerButtons={[
          {buttonType: 'default', content: 'Cancel', onClick: onDismiss},
          {buttonType: 'danger', content: buttonText, onClick: onConfirm},
        ]}
      >
        {text}
      </Dialog2>
    )
  )
}
